import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) =>
  state.salesOrganization || initialState;

export const selectSalesOrganization = createSelector(
  [selectSlice],
  state => state,
);
